var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkipForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 13C26 6.37258 20.4036 1 13.5 1C6.59644 1 1 6.37258 1 13C1 19.6274 6.59644 25 13.5 25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5498 17V8.672H11.6658V17H10.5498ZM8.84583 9.68V8.672H11.5458V9.68H8.84583ZM15.61 17.12C15.042 17.12 14.534 17.02 14.086 16.82C13.646 16.612 13.274 16.312 12.97 15.92L13.738 15.152C13.922 15.432 14.174 15.656 14.494 15.824C14.822 15.984 15.186 16.064 15.586 16.064C15.962 16.064 16.29 15.992 16.57 15.848C16.858 15.704 17.082 15.504 17.242 15.248C17.41 14.984 17.494 14.672 17.494 14.312C17.494 13.944 17.414 13.632 17.254 13.376C17.094 13.12 16.878 12.928 16.606 12.8C16.342 12.664 16.05 12.596 15.73 12.596C15.402 12.596 15.102 12.636 14.83 12.716C14.566 12.796 14.314 12.932 14.074 13.124L14.086 12.404C14.222 12.236 14.378 12.1 14.554 11.996C14.73 11.892 14.93 11.812 15.154 11.756C15.378 11.7 15.638 11.672 15.934 11.672C16.51 11.672 16.998 11.792 17.398 12.032C17.798 12.272 18.102 12.596 18.31 13.004C18.526 13.412 18.634 13.868 18.634 14.372C18.634 14.9 18.502 15.372 18.238 15.788C17.982 16.204 17.626 16.532 17.17 16.772C16.714 17.004 16.194 17.12 15.61 17.12ZM14.074 13.124L13.462 12.512L13.834 8.672H14.866L14.446 12.62L14.074 13.124ZM14.062 9.68L13.834 8.672H18.214V9.68H14.062Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0898 13.4072C20.9821 13.6253 20.9988 13.8967 21.1953 14.1104L25.4609 18.7461C25.5274 18.8182 25.6102 18.8762 25.7031 18.916C25.7961 18.9558 25.8976 18.9766 26 18.9766C26.1022 18.9765 26.2031 18.9557 26.2959 18.916C26.3888 18.8762 26.4717 18.8182 26.5381 18.7461L30.8047 14.1104C31.0018 13.8967 31.0187 13.6253 30.9111 13.4072C30.8035 13.1889 30.5703 13.0234 30.2666 13.0234L21.7334 13.0234C21.43 13.0236 21.1977 13.1892 21.0898 13.4072Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.046875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipForward);
export default __webpack_public_path__ + "static/media/skip-forward.389e18b86a575411a29d5adc86a87517.svg";
export { ForwardRef as ReactComponent };